
export const displayFriendComment = (category, friendInfo) => {
    
    let displayComment = false;
    if (category !== "SideHustle" &&
        friendInfo.friendName ){
            displayComment = true;
        }
  
    return displayComment;
}

